import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { client } from '../libs/client';
import FloatingCTA from './FloatingCTA';
import Footer from './Footer';
import Header from './Header';

function ColumnDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    client
      .get({
        endpoint: 'columns',
        contentId: id,
      })
      .then((res) => {
        setArticle(res);
      })
      .catch((error) => {
        console.error('microCMS detail error:', error);
      });
  }, [id]);

  if (!article) {
    return (
      <div className="column-detail-page">
        <Header />
        <section className="section column-detail-section">
          <div className="column-detail-container">
            <p className="column-detail-loading">読み込み中...</p>
          </div>
        </section>
        <Footer />
        <FloatingCTA />
      </div>
    );
  }

  return (
    <div className="column-detail-page">
      <Header />
      <section className="section column-detail-section">
        <div className="column-detail-container">
          <header className="column-detail-header">
            <p className="column-detail-label">Column</p>
            <time className="column-detail-date" dateTime={article.date}>
              {new Date(article.date).toLocaleDateString('ja-JP')}
            </time>

            <h1 className="column-detail-title">
              {article.title}
            </h1>
          </header>

          {article.eyecatch && (
            <figure className="column-detail-figure">
              <img
                src={article.eyecatch.url}
                alt={article.title}
                className="column-detail-image"
              />
            </figure>
          )}

          <article
            className="column-detail-content"
            dangerouslySetInnerHTML={{
              __html: article.content,
            }}
          />
        </div>
      </section>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default ColumnDetail;
